import * as types from './actionTypes';

export function locationHasChanged(location) {
  return {
    type: types.ROUTER_LOCATION_HAS_CHANGED,
    payload: { location },
  };
}
